export default __webpack_public_path__ + "static/media/Dante Symphony.97a62d67.png";